import { AgResourceLanguage } from '../types';
import { commonContent as EnUsCommonContent } from '../en-us/commonContent';

export const commonContent: AgResourceLanguage['commonContent'] = {
  ...EnUsCommonContent,
  orderBodyContent: {
    nextOnlyLabel: 'Engång',
    outOfStockLabel: 'Slut i lager',
    quantityLabel: 'Antal:',
    productHiddenLabel: 'Produkt',
    productsSubtitle: 'Produkter',
    subscriptionTitle: 'Subscription',
    otpTitle: 'This order only'
  },
  referFriendCard: {
    title: 'Bjud in Vänner',
    text: 'Få $15 för varje vän du hänvisar när de gör sitt första köp.'
  },
  slider: {
    empty: {
      title: 'Våra Abonnemang'
    },
    notEmpty: {
      title: 'AG1-butiken',
      description: 'Tillgänglig exklusivt för medlemmar'
    },
    cardContent: {
      addToSubscription: 'Lägg till i Abonnemang',
      addedToSubscription: 'Tillagd i Abonnemang',
      addToNextOrder: 'Lägg till i Nästa Beställning',
      addedToNextOrder: 'Tillagd i Nästa Beställning',
      maxQuantityReached: 'Max kvantitet uppnådd',
      agzOtpButton: 'for $99',
      agzDisclaimer: '† When bundled in a subscription with AG1. An AGZ only subscription is $79.'
    }
  },
  buttons: {
    subscribeAndSave: 'Prenumerera & Spara',
    subscribe: 'Prenumerera',
    delete: 'Radera'
  },
  status: {
    fulfilled: 'Genomförd',
    partial: 'Delvis genomförd',
    paid: 'Leverans pågår',
    refunded: 'Återbetald',
    partially: 'Delvis återbetald',
    unpaid: 'Obetald'
  },
  statusV2: {
    Unfulfilled: 'Förbereder',
    Fulfilled: 'Skickad',
    'On hold': 'Förbereder'
  }
};
